<template>
  <div class="max-w-[1280px] mx-auto my-8 px-6">
    <div class="flex justify-between items-center mb-8">
      <h1 class="font-[Poppins] font-bold text-2xl text-[#191c1e]">
        Tekniker & verktyg
      </h1>
      <Button as="a" :href="newTechniquePath">Ny teknik</Button>
    </div>

    <div class="rounded-2xl border border-[#e6e8ea] overflow-hidden">
      <table class="w-full text-sm">
        <thead
          class="bg-[#f2f4f6] text-[#6c7a77] text-[12px] uppercase tracking-wide font-semibold"
        >
          <tr>
            <th class="text-left px-4 py-3">Titel</th>
            <th class="text-left px-4 py-3">Badge</th>
            <th class="text-left px-4 py-3">Lästid</th>
            <th class="text-left px-4 py-3">Status</th>
            <th class="text-left px-4 py-3"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="technique in techniques"
            :key="technique.id"
            class="border-t border-[#e6e8ea] hover:bg-[#f9fafb] transition-colors"
          >
            <td class="px-4 py-3 font-medium text-[#191c1e]">
              {{ technique.title }}
            </td>
            <td class="px-4 py-3">
              <span
                class="inline-block px-2.5 py-0.5 rounded-full text-[11px] font-bold tracking-widest"
                :style="{
                  backgroundColor: technique.badgeColor,
                  color: '#fff',
                }"
                >{{ technique.badge }}</span
              >
            </td>
            <td class="px-4 py-3 text-[#6c7a77]">{{ technique.readTime }}</td>
            <td class="px-4 py-3">
              <span
                class="inline-block px-2 py-0.5 rounded-full text-[11px] font-semibold"
                :class="
                  technique.published
                    ? 'bg-teal-100 text-teal-700'
                    : 'bg-gray-100 text-gray-500'
                "
                >{{ technique.published ? "Publicerad" : "Utkast" }}</span
              >
            </td>
            <td class="px-4 py-3 text-right">
              <Link
                :href="technique.editPath"
                class="text-teal-600 hover:underline mr-4 font-medium text-xs"
              >
                Redigera
              </Link>
              <button
                class="text-red-500 hover:underline font-medium text-xs cursor-pointer"
                @click="destroy(technique)"
              >
                Ta bort
              </button>
            </td>
          </tr>
          <tr v-if="techniques.length === 0">
            <td colspan="5" class="px-4 py-8 text-center text-[#6c7a77]">
              Inga tekniker ännu.
              <Link
                :href="newTechniquePath"
                class="text-teal-600 hover:underline"
                >Skapa den första.</Link
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { Link, router } from "@inertiajs/vue3";
import { Button } from "@/components/ui/button";

const props = defineProps({
  techniques: { type: Array, required: true },
  newTechniquePath: { type: String, required: true },
});

function destroy(technique) {
  if (!confirm(`Ta bort "${technique.title}"? Detta kan inte ångras.`)) return;
  router.delete(technique.deletePath, { preserveScroll: true });
}
</script>
